// extracted by mini-css-extract-plugin
export default {"card":"StationCard_card__iEdBi","title":"StationCard_title__D00SN","value":"StationCard_value__MSFwE"};